  // import { api } from "../Components/base_service";

  // const RfqService = {
  //   getAllRfqs: async () => {
  //     try {
  //       const response = await api.get("api/rfq");

  //       console.log("RFQ API Response:", response);

  //       if (response.errorCode === "0") {
  //         return { success: true, data: response.responseBody };
  //       } else {
  //         return {
  //           success: false,
  //           message: response?.errorMessage || "Failed to fetch RFQs",
  //         };
  //       }
  //     } catch (err) {
  //       console.error("RFQ fetch error:", err.message);
  //       return {
  //         success: false,
  //         message: err.message || "Something went wrong while fetching RFQs",
  //       };
  //     }
  //   },



  //   getAllSalesOrders: async () => {
  //     try {
  //       const response = await api.get("api/salesorder?page=0&size=20");

  //       console.log("Sales Orders API Response:", response);

  //       if (response.errorCode === "0") {
  //         return { success: true, data: response.responseBody };
  //       } else {
  //         return {
  //           success: false,
  //           message: response?.errorMessage || "Failed to fetch sales orders",
  //         };
  //       }
  //     } catch (err) {
  //       console.error("Sales Orders fetch error:", err.message);
  //       return {
  //         success: false,
  //         message: err.message || "Something went wrong while fetching sales orders",
  //       };
  //     }
  //   },



    
  //   getAllQuotations: async () => {
  //     try {
  //       const response = await api.get("api/quatation?type=QuotationSent&page=0&size=20");

  //       console.log("Quotations API Response:", response);

  //       if (response.errorCode === "0") {
  //         return { success: true, data: response.responseBody };
  //       } else {
  //         return {
  //           success: false,
  //           message: response?.errorMessage || "Failed to fetch quotations",
  //         };
  //       }
  //     } catch (err) {
  //       console.error("Quotations fetch error:", err.message);
  //       return {
  //         success: false,
  //         message: err.message || "Something went wrong while fetching quotations",
  //       };
  //     }
      
  //   },
  // };
  // export default RfqService;

  import { api } from "../Components/base_service";

const RfqService = {
  getAllRfqs: async () => {
    try {
      const response = await api.get("api/rfq/all");

      console.log("RFQ API Response:", response);

      if (response.errorCode === "0") {
        return { success: true, data: response.responseBody };
      } else {
        return {
          success: false,
          message: response?.errorMessage || "Failed to fetch RFQs",
        };
      }
    } catch (err) {
      console.error("RFQ fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching RFQs",
      };
    }
  },

  getAllSalesOrders: async () => {
    try {
      const response = await api.get("api/salesorder/all?page=0&size=20");

      console.log("Sales Orders API Response:", response);

      if (response.errorCode === "0") {
        return { success: true, data: response.responseBody };
      } else {
        return {
          success: false,
          message: response?.errorMessage || "Failed to fetch sales orders",
        };
      }
    } catch (err) {
      console.error("Sales Orders fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching sales orders",
      };
    }
  },

  getAllQuotations: async () => {
    try {
      const response = await api.get("api/quatation/all?type=QuotationSent&page=0&size=20");

      console.log("Quotations API Response:", response);

      if (response.errorCode === "0") {
        return { success: true, data: response.responseBody };
      } else {
        return {
          success: false,
          message: response?.errorMessage || "Failed to fetch quotations",
        };
      }
    } catch (err) {
      console.error("Quotations fetch error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while fetching quotations",
      };
    }
  },

  // New method to handle POST request for submitting RFQ
  postRfq: async (payload) => {
    try {
      const response = await api.post("api/rfq", payload);

      console.log("RFQ Submit API Response:", response);

      if (response.errorCode === "0") {
        return { success: true, data: response.responseBody };
      } else {
        return {
          success: false,
          message: response?.errorMessage || "Failed to submit RFQ",
        };
      }
    } catch (err) {
      console.error("RFQ submit error:", err.message);
      return {
        success: false,
        message: err.message || "Something went wrong while submitting RFQ",
      };
    }
  },
};

export default RfqService;
